"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _Teams = /*#__PURE__*/ _interop_require_default(require("./Teams"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let TeamsPlugin = class TeamsPlugin extends _ncplugin.XcWebhookNotificationPlugin {
    getAdapter() {
        return TeamsPlugin.notificationAdapter;
    }
    async init(_config) {
        TeamsPlugin.notificationAdapter = new _Teams.default();
        await TeamsPlugin.notificationAdapter.init();
    }
};
const _default = TeamsPlugin;
